import { createBrowserRouter } from 'react-router'

import Layout from './components/Layout/Layout'
import ExploitDemo from './pages/ExploitDemo'
import Notfound from './pages/Notfound'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <ExploitDemo />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
])

export default router
